import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Grow,
  CircularProgress,
} from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

export const LaunchCampaignModal = ({ open, onClose, campaign, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);

    try {
      await onConfirm();
    } catch (error) {
      console.error('Error en handleConfirm:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleClose();
      }}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Grow}
      transitionDuration={300}
      disableEscapeKeyDown
    >
      <DialogContent sx={{ pt: 4 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <RocketLaunchIcon
            sx={{
              fontSize: 64,
              color: 'primary.main',
            }}
          />
        </Box>

        <DialogContentText
          sx={{
            textAlign: 'center',
            color: 'text.primary',
            mb: 1,
          }}
        >
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            ¿Estás seguro que deseas lanzar esta campaña?
          </Typography>
        </DialogContentText>

        {campaign?.nombre && (
          <DialogContentText
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              mb: 1,
            }}
          >
            <Typography variant="body2" component="span">
              Campaña: <strong>{campaign.nombre}</strong>
            </Typography>
          </DialogContentText>
        )}

        <DialogContentText
          sx={{
            textAlign: 'center',
            color: 'error.main',
            fontWeight: 500,
          }}
        >
          Una vez lanzada, la campaña no podrá ser cancelada.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center', gap: 2 }}>
        <Button onClick={handleClose} variant="outlined" size="large" disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          size="large"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
          sx={{ minWidth: 120 }}
        >
          {loading ? 'Lanzando...' : 'Lanzar Campaña'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LaunchCampaignModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  campaign: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombre: PropTypes.string,
  }),
  onConfirm: PropTypes.func.isRequired,
};